import { ApiError, ApiErrorData } from "@steto-care/steto-query";

export const AUTH_ERROR_MAPPING: Record<string, string> = {
  TOO_MANY_ATTEMPTS: "errors.tooManyAttempts",
  INVALID_LOGIN_CODE: "errors.wrongCode",
};

/**
 * useAPIErrorMessageParser keys off the `error` string only and ignores the
 * status code, so the throttling and bad-code cases have to be named first.
 */
export const toAuthErrorData = (error: ApiError | null | undefined): ApiErrorData | undefined => {
  if (!error) {
    return undefined;
  }
  if (error.data.statusCode === 429) {
    return { ...error.data, error: "TOO_MANY_ATTEMPTS" };
  }
  if (error.data.statusCode === 401 && error.data.error === "INVALID_TOKEN") {
    return { ...error.data, error: "INVALID_LOGIN_CODE" };
  }
  return error.data;
};
